import * as caseTypes from './casesTypes';

const initialState = {
  caseIds: null,
  caseIdsFailure: false,
  caseDetails: {},
  caseDetailsHeader: {},
  caseManagerId: null,
  caseMessagesCount: 0,
  tableData: [],
  consentsData: [],
  filters: {},
  caseDocuments: [],
  showFilterModal: false,
  immigrationPathwayList: [],
  casePhases: {},
  isLoading: false,
  productsList: [],
  showToastMessage: false,
  toastMessage: '',
  createQuestSuccess: false,
  createQuestPending: false,
  frequencyList: [],
  caseStatusList:[],
  experianResults: {},
  experianPDF: {},
  experianBgCheckResults: {},
  downloadExperianPdfSuccess: false,
  eyStatus: {},
  eyStatusApiResult: {},
  primaryContacts: {},
  secondaryContacts: {},
  teritaryContacts: {},
  cOEMemberContacts: {},
  delegateContacts: {},
  eyStatusCountry: '',
  experianChatMessage: '',
  extensionDetails:{},
  missingInfo:[],
  questionnaireAccessList:[],
};

const casesReducer = (state = initialState, action) => {
  switch (action.type) {
    case caseTypes.GET_IMMIGRATION_PATHWAY_SUCCESS: {
      return { ...state, immigrationPathwayList: action.payload };
    }
    case caseTypes.SET_CASES_PARAMS_SUCCESS: {
      return { ...state, casesPayload: action.payload };
    }
    case caseTypes.GET_EXTENSION_DETAILS_CONTACTS: {
      return { ...state, extensionDetails: action.payload };
    }
    case caseTypes.GET_PRIMARYCASE_CONTACTS: {
      return { ...state, primaryContacts: action.payload };
    }
    case caseTypes.GET_SECONDARYCASE_CONTACTS: {
      return { ...state, secondaryContacts: action.payload };
    }
    case caseTypes.GET_TERITARY_CONTACTS: {
      return { ...state, teritaryContacts: action.payload };
    } 
    case caseTypes.GET_COE_MEMBER_CONTACTS: {
      return { ...state, cOEMemberContacts: action.payload };
    }

    case caseTypes.GET_DELEGATECASE_CONTACTS: {
      return { ...state, delegateContacts: action.payload };
    }
    case caseTypes.SET_POPULATE_PAYLOAD_SUCCESS: {
      return { ...state, populatePayload: action.flag };
    }
    case caseTypes.GET_CASES_SUCCESS: {
      return { ...state, tableData: action.payload };
    }

    case caseTypes.GET_NEW_CASES_SUCCESS: {
      return { ...state, dashboardcasetableData: action.payload };
    }
    
    case caseTypes.GET_CASE_CONSENTS_SUCCESS: {
      return { ...state, consentsData: action.data.response };
    }

    case caseTypes.GET_CASE_IDS_SUCCESS:
      return { ...state, caseIds: action.payload.cases };
    case caseTypes.GET_CASE_IDS_FAILURE:
      return { ...state, caseIdsFailure: true };

    case caseTypes.GET_CASE_DETAILS_SUCCESS:
      return { ...state, caseDetails: action.caseDetails, caseDetailsHeader: action.caseDetailsHeader };

    case caseTypes.GET_CASES_MESSAGES_COUNTS_SUCCESS: {
      return { ...state, caseMessagesCount: action.data.messages.length };
    }
    case caseTypes.GET_CASES_MESSAGES_COUNTS_FAILURE: {
      return { ...state, caseMessagesCount: 0 };
    }
    case caseTypes.GET_CASE_DETAIL_FAILURE:
      return { ...state, caseDetailFailure: true };
    case caseTypes.SHOW_FILTER_MODAL:
      return {
        ...state,
        showFilterModal: action.status,
        anchorModal: action.anchorEl,
      };
      case caseTypes.STORE_CASE_DETAILS:
        return {
          ...state,
          caseDetails: {
            ...action.caseDetails,
            linkedcasespresent:
              typeof action.caseDetails.linkedcasespresent !== 'undefined'
                ? action.caseDetails.linkedcasespresent
                : state.caseDetails && typeof state.caseDetails.linkedcasespresent !== 'undefined'
                ? state.caseDetails.linkedcasespresent
                : false,
          },
        };
    case caseTypes.GET_ADDITIONAL_INFO_SUCCESS:
      return {
        ...state,
        caseDetails: {...state.caseDetails, ...action.caseDetails},
      };
    case caseTypes.UPDATE_RELATED_RETURN_STORE:
      return {
        ...state,
        caseDetails: {...state.caseDetails, relatedReturn: action.relatedReturn},
      };
    case caseTypes.STORE_CASE_MANAGER_ID:
      return {
        ...state,
        caseManagerId: action.caseManagerId,
      };
    case caseTypes.RESET_CASE_MANAGER_ID:
      return {
        ...state,
        caseManagerId: null,
      };
    case caseTypes.GET_FILTERS_SUCCESS:
      return {
        ...state,
        filters: action.payload,
      };
    case caseTypes.HYDRATE_CASES:
      return {
        ...state,
        caseDocuments: action.payload,
      };
    case caseTypes.GET_CASE_PHASES_SUCCESS:
      return { ...state, casePhases: action.data };
    case caseTypes.GET_PRODUCTLIST_BY_ORGYEAR_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case caseTypes.GET_PRODUCTLIST_BY_ORGYEAR_SUCCESS:
      return {
        ...state,
        productsList: action.payload.productsList,
        isLoading: false,
      };
    case caseTypes.GET_PRODUCTLIST_BY_ORGYEAR_FAILURE:
      return {
        ...state,
        caseDocuments: action.error,
        productsList: {},
        isLoading: false,
      };
    case caseTypes.CREATE_TAXCHAT_QUESTIONNAIRE_PENDING:
      return {
        ...state,
        createQuestSuccess: false,
        createQuestPending: true,
      };
    case caseTypes.CREATE_TAXCHAT_QUESTIONNAIRE_SUCCESS:
      return {
        ...state,
        createQuestSuccess: action.payload.response.success,
        createQuestPending: false,
      };
    case caseTypes.CREATE_TAXCHAT_QUESTIONNAIRE_FAILURE:
      return {
        ...state,
        createQuestSuccess: false,
        createQuestPending: false,
      };
    case caseTypes.SHOW_CREATE_QUEST_NOTIFICATION_SUCCESS:
      return { ...state, showToastMessage: true, toastMessage: action.message };
    case caseTypes.HIDE_CREATE_QUEST_NOTIFICATION_SUCCESS:
      return { ...state, showToastMessage: false };

    case caseTypes.GET_ENGAGEMENT_FREQUENCY_LIST: {
      return { ...state, frequencyList: action.data };
    }
    case caseTypes.GET_CASE_STATUS_SUCCESS: {
      return { ...state, caseStatusList: action.data };
    }
    case caseTypes.GET_QUESTIONNAIRE_SUCCESS: {
      return { ...state, questionnaireAccessList: action.data };
    }
    case caseTypes.GET_EXPERIAN_RESULTS_SUCCESS:
      return {
        ...state,
        experianResults: action.data,
      };
    case caseTypes.GET_EXPERIAN_RESULTS_FAILURE:
      return {
        ...state,
        experianResults: {},
      };
    case caseTypes.GET_EXPERIAN_BGCHECK_RESULTS_SUCCESS:
      return {
        ...state,
        experianBgCheckResults: action.data,
      };
    case caseTypes.GET_EXPERIAN_BGCHECK_RESULTS_FAILURE:
      return {
        ...state,
        experianBgCheckResults: {},
      };
    case caseTypes.GET_EXPERIAN_PDF_SUCCESS:
      return {
        ...state,
        experianPDF: action.data,
      };
    case caseTypes.GET_EXPERIAN_PDF_FAILURE:
      return {
        ...state,
        experianPDF: {},
      };
    case caseTypes.GET_EXPERIAN_TEST_EXPORT_TO_PDF_SUCCESS:
      return {
        ...state,
        downloadExperianPdfSuccess: action.payload.success,
      };
    case caseTypes.GET_EY_STATUS_SUCCESS:
      return {
        ...state,
        eyStatus: {...action.data, totalAPIRows:action.totalAPIRows},
      };
    case caseTypes.GET_EY_STATUS_SUCCESS_API_TABLE:
      return {
        ...state,
        eyStatusApiResult: action.data,
      };
    case caseTypes.GET_EY_STATUS_COUNTRY:
      return {
        ...state,
        eyStatusCountry: action.data,
      };
    case caseTypes.EY_FILE_BUTTON:
      return {
        ...state,
        eyStatus: { ...state.eyStatus, isInitiateEFileEnable: action.data },
      };
    case caseTypes.EXPERIAN_CHAT_MESSAGE:
      return {
        ...state,
        experianChatMessage: action.data,
      };
    case caseTypes.FAVORITE_CHECKBOX: {
      let caseFavoriteNew = state.tableData.cases.slice();
      caseFavoriteNew[action.payload].isFavorite = action.isChecked;
      return {
        ...state,
        tableData: { ...state.tableData, cases: caseFavoriteNew },
      };
    }
    case caseTypes.GET_LOGS_LIST_SUCCESS: {
      return { ...state, logsList: action.logs };
    }
    case caseTypes.GET_MISSING_INFO:
      let documentAllowSpecialChars= action.data && action.data.allowedSpecialChars;
      let additionalRestriction= ["÷", "₹", "¥", "₩", "#","^","~","<",">","|","{","}","\\[","\\]"]; 
      additionalRestriction.filter((item,index)=> {let findList=documentAllowSpecialChars.indexOf(item)
        if(findList>-1){
          additionalRestriction.splice(index,1);
        }
      })
      return {
        ...state,
        missingInfo : {additionalCharRestict: additionalRestriction, ...action.data },
      };
    case caseTypes.GET_MISSING_INFO_FAILURE:
      return {
        ...state,
        missingInfo : [],
      };
    case caseTypes.SET_FOLLOWUP_ACKNOWLEDGE_SUCCESS:
      let missingInfoDetailsId = action.missingInfoDetailsId;
      let updatedMissingInfo = (state.missingInfo.missingInfoQuestionResponse || []).map(item => {
        if (item.missingInfoDetailsId === missingInfoDetailsId) {
          return { ...item, acknowledge: true };
        }
        return item;
      });
      return {
        ...state,
        missingInfo: { ...state.missingInfo, missingInfoQuestionResponse: updatedMissingInfo },
      };
    default:
      return state;
  }
};

export { initialState };
export default casesReducer;
